import { Card, Badge, Button } from '../../components/ui';
import { formatFechaLarga, formatHora } from '../../utils/fechas';
import { estadoInfo, nombreSede } from './MisTurnosUtils';
import './MisTurnos.css';

export default function Turno({ turno, onCancel, showCancel = false }) {
  const estado = estadoInfo(turno.estado);

  return (
    <Card as="article" data-testid="turno">
      <div className="mis-turnos-card-top">
        <span>{formatFechaLarga(turno.fechaYHora)}</span>
        <Badge tone={estado.tone} dot>{estado.label}</Badge>
      </div>
      <dl className="mis-turnos-detail-grid">
        <div>
          <dt>Hora</dt>
          <dd>{formatHora(turno.fechaYHora)}</dd>
        </div>
        <div>
          <dt>Médico</dt>
          <dd>{turno.medico || '—'}</dd>
        </div>
        <div>
          <dt>Sede</dt>
          <dd>{nombreSede(turno.sede)}</dd>
        </div>
      </dl>
      {showCancel && (
        <div className="mis-turnos-card-actions">
          <Button variant="dangerSoft" size="sm" data-testid="cancelar-turno" onClick={() => onCancel(turno)}>
            Cancelar turno
          </Button>
        </div>
      )}
    </Card>
  );
}